import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";
import { Factory } from "@phosphor-icons/react";

export default function Login() {
  const { user, login, error } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/app" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    await login(email, password);
    setBusy(false);
  };

  return (
    <div className="employee-login min-h-[100dvh] grid grid-cols-1 md:grid-cols-2" data-testid="login-page">
      <div
        className="employee-login-visual hidden md:block relative"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1503694978374-8a2fa686963a?q=80&w=1600')",
          backgroundSize: "cover", backgroundPosition: "center",
        }}
      >
        <div className="employee-login-overlay absolute inset-0 p-10 flex flex-col justify-between text-white">
          <div>
            <div className="employee-login-brand font-heading font-black text-3xl"><span>JYOTI</span> <span>IMAGE</span></div>
            <div className="text-xs uppercase tracking-widest font-mono opacity-70 mt-1">CTP · Workflow · Inventory · Challans</div>
          </div>
          <div>
            <h1 className="font-heading font-black text-4xl leading-tight max-w-md">Precision plate production. Every job, every plate, tracked.</h1>
            <p className="text-sm opacity-80 mt-3 max-w-md">AMSKY · CRON · KODAK — one central operational system replacing spreadsheets.</p>
          </div>
        </div>
      </div>
      <div className="employee-login-panel flex items-center justify-center p-4 sm:p-8">
        <form onSubmit={submit} className="employee-login-form w-full max-w-sm space-y-4" data-testid="login-form">
          <div className="employee-login-title flex items-center gap-2 mb-6">
            <Factory size={28} weight="duotone" />
            <div className="font-heading font-black text-xl">Sign in</div>
          </div>
          <label className="block">
            <div className="text-xs font-semibold uppercase tracking-wider text-zinc-500 mb-1">Employee ID or Email</div>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="employee-login-input w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-zinc-950"
              required
              data-testid="login-email"
            />
          </label>
          <label className="block">
            <div className="text-xs font-semibold uppercase tracking-wider text-zinc-500 mb-1">Password</div>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="employee-login-input w-full border border-zinc-300 rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-zinc-950"
              required
              data-testid="login-password"
            />
          </label>
          {error && <div className="text-sm text-red-600 font-medium" data-testid="login-error">{error}</div>}
          <button
            type="submit"
            disabled={busy}
            className="employee-login-submit w-full bg-zinc-950 hover:bg-zinc-800 text-white font-semibold text-sm py-2.5 rounded-sm transition-colors disabled:opacity-60"
            data-testid="login-submit"
          >{busy ? "Signing in…" : "Sign in"}</button>
        <a href="/" className="block text-center text-xs font-semibold text-zinc-500 hover:text-zinc-950 transition-colors">← Back to Jyoti Image website</a>
        </form>
      </div>
    </div>
  );
}
